/* SPICY SOUTH: homepage v2 controller ("ssh"). 2026-10-04.
   1. Scroll reveal ([data-ssh-reveal]) and the steps clock count-up.
   2. The heat dial: drag, tap a notch, tap a chip, or arrow keys; snaps
      to stops, drives --heat (needle, arc, ember glow) and turns the
      matching card in.
   3. Quick add: posts to /cart/add.js, then raises the theme's own
      cart:update event with the drawer's section HTML, so the existing
      cart drawer (auto-open, GoKwik checkout) opens with the line in it.
      No new cart, no new checkout path. Any failure falls back to the
      plain form post.
   No dependencies. Transform/opacity only. Reduced motion honoured. */
(function () {
  if (window.__sshBooted) return;
  window.__sshBooted = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. reveal --------------------------------------------- */
  function reveal() {
    var els = document.querySelectorAll('[data-ssh-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); clock(el); });
      return;
    }
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add('is-in');
    });
    document.documentElement.classList.add('ssh-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        clock(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll('[data-ssh-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  function clock(el) {
    if (!el.hasAttribute('data-ssh-clock') || el.dataset.counted) return;
    el.dataset.counted = '1';
    var num = el.querySelector('[data-ssh-num]');
    var to = parseInt(el.dataset.to, 10) || 25;
    if (!num || reduce) return;
    var t0 = null, dur = 1600;
    function tick(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      num.textContent = Math.round(e * to);
      if (k < 1) requestAnimationFrame(tick);
    }
    num.textContent = '0';
    requestAnimationFrame(tick);
  }

  /* ---------- 2. heat dial ------------------------------------------ */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function dial(root) {
    if (root.dataset.sshInit) return;
    root.dataset.sshInit = '1';
    var face = root.querySelector('[data-ssh-face]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ssh-match]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ssh-stop]'));
    var now = root.querySelector('[data-ssh-now]');
    var notchG = root.querySelector('[data-ssh-notches]');
    var n = cards.length;
    if (!face || n < 2) return;
    var cx = 160, cy = 160, r = 134;
    var notches = [];
    for (var i = 0; i < n; i++) {
      var a = Math.PI - (Math.PI * i) / (n - 1);
      var c = document.createElementNS(SVGNS, 'circle');
      c.setAttribute('cx', (cx + (r + 24) * Math.cos(a)).toFixed(2));
      c.setAttribute('cy', (cy - (r + 24) * Math.sin(a)).toFixed(2));
      c.setAttribute('r', '4');
      c.setAttribute('class', 'ssh-dial__notch');
      c.dataset.i = i;
      notchG.appendChild(c);
      notches.push(c);
    }
    var cur = -1;
    function set(i, user) {
      i = Math.max(0, Math.min(n - 1, i));
      if (i === cur) return;
      var prev = cur;
      cur = i;
      var heat = i / (n - 1);
      root.style.setProperty('--heat', heat.toFixed(3));
      var card = cards[i];
      var name = card.dataset.short || '';
      if (now) now.textContent = name;
      face.setAttribute('aria-valuenow', i + 1);
      face.setAttribute('aria-valuetext', name + (card.dataset.state ? ', ' + card.dataset.state : ''));
      notches.forEach(function (c, k) {
        c.classList.toggle('is-on', k <= i);
        c.classList.toggle('is-now', k === i);
        c.setAttribute('r', k === i ? '6' : '4');
      });
      chips.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      var rev = prev > i;
      cards.forEach(function (el, k) {
        el.classList.remove('is-in', 'is-out', 'is-rev');
        if (k === i) {
          el.classList.add('is-active');
          el.removeAttribute('aria-hidden');
          if (prev !== -1 && !reduce) {
            void el.offsetWidth;
            el.classList.add('is-in');
            if (rev) el.classList.add('is-rev');
          }
        } else if (k === prev && !reduce) {
          el.classList.remove('is-active');
          el.setAttribute('aria-hidden', 'true');
          el.classList.add('is-out');
          if (rev) el.classList.add('is-rev');
        } else {
          el.classList.remove('is-active');
          el.setAttribute('aria-hidden', 'true');
        }
      });
      /* lazy images: promote the visible card and its neighbours */
      [i - 1, i, i + 1].forEach(function (k) {
        var img = cards[k] && cards[k].querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
      if (user) {
        root.classList.add('is-touched');
        if (navigator.vibrate && !reduce) { try { navigator.vibrate(6); } catch (e) {} }
      }
    }
    function fromPoint(x, y) {
      var b = face.getBoundingClientRect();
      var px = ((x - b.left) / b.width) * 320;
      var py = ((y - b.top) / b.height) * 176;
      var ang = Math.atan2(cy - py, px - cx);
      if (ang < 0) ang = px < cx ? Math.PI : 0;
      var t = 1 - ang / Math.PI;
      return Math.round(t * (n - 1));
    }
    var dragging = false;
    face.addEventListener('pointerdown', function (e) {
      dragging = true;
      root.classList.add('is-dragging');
      try { face.setPointerCapture(e.pointerId); } catch (err) {}
      set(fromPoint(e.clientX, e.clientY), true);
    });
    face.addEventListener('pointermove', function (e) {
      if (dragging) set(fromPoint(e.clientX, e.clientY), true);
    });
    function end() { dragging = false; root.classList.remove('is-dragging'); }
    face.addEventListener('pointerup', end);
    face.addEventListener('pointercancel', end);
    face.addEventListener('keydown', function (e) {
      var k = e.key, d = 0;
      if (k === 'ArrowRight' || k === 'ArrowUp') d = 1;
      else if (k === 'ArrowLeft' || k === 'ArrowDown') d = -1;
      else if (k === 'Home') { e.preventDefault(); set(0, true); return; }
      else if (k === 'End') { e.preventDefault(); set(n - 1, true); return; }
      if (!d) return;
      e.preventDefault();
      set(cur + d, true);
    });
    chips.forEach(function (b) {
      b.addEventListener('click', function () { set(parseInt(b.dataset.sshStop, 10), true); });
    });
    root.classList.add('is-ready');
    set(parseInt(root.dataset.start, 10) || 0, false);
  }

  /* ---------- 3. quick add ------------------------------------------ */
  function drawerSectionId() {
    var el = document.querySelector('cart-items-component[data-drawer][data-section-id]') ||
             document.querySelector('cart-items-component[data-section-id]');
    return el ? el.dataset.sectionId : null;
  }
  function onAdd(e) {
    var form = e.target.closest && e.target.closest('[data-ssh-addform]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[data-ssh-add]');
    var scope = form.closest('.ssh-match__buy, .ssh-box__body') || form.parentNode;
    var msg = scope && scope.querySelector('[data-ssh-msg]');
    if (!btn || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    if (msg) msg.textContent = '';
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var sid = drawerSectionId();
    var body = { items: [{ id: id, quantity: 1 }] };
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var added;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw res.j;
        added = res.j;
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-done');
        if (msg) msg.textContent = '';
        setTimeout(function () { btn.classList.remove('is-done'); }, 2400);
        var detail = {
          resource: cart,
          sourceId: 'ssh-home',
          data: { source: 'ssh-home', itemCount: cart.item_count, variantId: String(id), sections: (added && added.sections) || {} }
        };
        var ev;
        try { ev = new CustomEvent('cart:update', { bubbles: true, detail: detail }); }
        catch (err) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('cart:update', true, false, detail); }
        document.dispatchEvent(ev);
        /* the drawer opens itself on cart:update when auto-open is set;
           if this theme has no auto-open drawer, open it by hand */
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
        if (!drawer) window.location.href = root + 'cart';
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        var text = (err && (err.description || err.message)) || '';
        if (msg) msg.textContent = text ? String(text) : 'Could not add that. Please try again.';
      });
  }

  /* ---------- in-page anchors: smooth, and the reviews target -------- */
  function anchors() {
    var rv = document.querySelector('.ss-reviews');
    if (rv && !document.getElementById('ssh-reviews')) { rv.id = 'ssh-reviews'; rv.style.scrollMarginTop = '64px'; }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.pathname !== window.location.pathname || !url.hash || url.hash.length < 2) return;
      var t = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!t || !(t.closest('.ssh-dial') || t.id === 'ssh-reviews' || t.classList.contains('ssh-dial'))) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', url.hash);
    });
  }

  function boot() {
    reveal();
    document.querySelectorAll('[data-ssh-dial]').forEach(dial);
  }
  document.addEventListener('submit', onAdd);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); anchors(); });
  else { boot(); anchors(); }
  document.addEventListener('shopify:section:load', boot);
})();
